export default __webpack_public_path__ + "static/media/WallNotification_Chicago-Picture.0e65a9bc.png";